import React, { FC, useCallback, useEffect } from 'react';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { setRefresh } from 'src/modules/shared/slices/filters/entity/FiltersSlice';
import { useUser } from 'src/modules/shared';
import { CircularProgress } from '@material-ui/core';

const TrajectoryControls: FC = () => {
  const dispatch = useAppDispatch();
  const refresh = useAppSelector((state) => state.filters.refresh);
  const selectedGroup = useAppSelector((state) => state.filters.selectedGroup);
  const isFetching = useAppSelector((state) => state.filters.isFetching);
  const { isStudent } = useUser();

  const handleRefreshScoresAndProgress = useCallback(() => {
    dispatch(setRefresh(true));
  }, [dispatch]);

  useEffect(() => {
    if (refresh) dispatch(setRefresh(false));
  }, [refresh, dispatch]);

  return (
    <>
      {isFetching ? (
        <CircularProgress size={16} />
      ) : (
        <FontAwesomeSpriteButton
          icon={SpriteIconsLight.REFRESH}
          onClick={handleRefreshScoresAndProgress}
          disabled={!isStudent && selectedGroup === ''}
          iconSize="xl"
        />
      )}
    </>
  );
};

export default TrajectoryControls;
